import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-38f116c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "flexDiv" }
const _hoisted_2 = { style: {"margin-top":"20px"} }

import { reactive, onMounted, ref, watch } from 'vue';

import { ElMessage, ElTree } from 'element-plus';
import { Search } from '@element-plus/icons-vue';

/* Apis */
import { GetDeptCascaderTreeApi } from '@/apis/basics/department/apis';
import { propTypes } from '@/utils/propTypes';


export default /*#__PURE__*/_defineComponent({
  props: {
    pid: propTypes.string.def('')
},
  emits: ['nodeChange'],
  setup(__props, { emit: $emits }) {

const $props = __props




const treeRef = ref<InstanceType<typeof ElTree>>();

const state = reactive({
    filterText: '',
    datalist: []
})

const filterNode = (value: string, data: any) => {
    if (!value) return true
    return data.name.includes(value)
}

/* 加载数据 */
const load = {
    /* 部门联级选择 */
    getDeptTrees: async (cmpId: string) => {
        const { succeeded, errors, data } = await GetDeptCascaderTreeApi(cmpId)
        if (!succeeded) {
            ElMessage.error(errors)
        } else {
            state.datalist = data || []
        }
    },
}

watch(() => state.filterText, (val: string) => {
    treeRef.value!.filter(val);
});

/* 点击节点 */
const onTreeNodeClick = (node: any) => {
    $emits('nodeChange', node.id)
}

onMounted(() => {
    load.getDeptTrees($props.pid)
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_text = _resolveComponent("el-text")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { shadow: "never" }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_input, {
          "prefix-icon": _unref(Search),
          modelValue: _unref(state).filterText,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(state).filterText) = $event)),
          placeholder: "请输入关键字查询"
        }, null, 8, ["prefix-icon", "modelValue"])
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(ElTree), {
          ref_key: "treeRef",
          ref: treeRef,
          data: _unref(state).datalist,
          props: { label: 'dept_name' },
          "filter-node-method": filterNode,
          "default-expand-all": false,
          "default-expanded-keys": ['542e51ab-8999-4625-aa6a-38bd993a4dfa'],
          "highlight-current": "",
          "node-key": "id",
          accordion: "",
          "expand-on-click-node": false,
          onNodeClick: onTreeNodeClick
        }, {
          default: _withCtx(({ node, data }) => [
            _createVNode(_component_el_text, {
              class: "mx-1",
              truncated: ""
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(node.label), 1)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        }, 8, ["data"])
      ])
    ]),
    _: 1
  }))
}
}

})